export const appStoreUrl = "https://apps.apple.com/us/app/id1573789293";
